import React from 'react';
import { components } from 'react-select';
import classnames from 'classnames';
import { createE2EClass } from '@Utils/String';

/**
 * custom control component with wrapper for size styling support
 */
export const SelectContainer = ({children, ...props}) => {
  return (
    <div className={classnames(props.selectProps.customCssClass,
        {['rx-select-size-wrap-' + props.selectProps.size]: props.selectProps.size}
      )}>
      <components.SelectContainer {...props}>
        {children}
      </components.SelectContainer>
    </div>
  );
};

/**
* custom control component with wrapper for styling control
*/
export const Control = ({children, ...props}) => {
  return (
    <div className={classnames(props.selectProps.classNamePrefix + '__control-wrap', {
      [props.selectProps.classNamePrefix + '__control-wrap--menu-is-open']: props.selectProps.menuIsOpen
    })}>
      <components.Control {...props}>
        {children}
      </components.Control>
    </div>
  );
};

/**
 * render custom value container content from props.customValueRenderer if provided
 * also renders input component to not broke inner select functionality
 * @param customValueRenderer
 */
export const ValueContainer = (customValueRenderer) => ({children, ...props}) => {
  return (
    <>
      {props.selectProps.inputValue && <components.Placeholder {...props} className='rx-select__placeholder--up'>{props.selectProps.placeholder}</components.Placeholder>}
      <components.ValueContainer {...props}>
        {customValueRenderer ?
          <>
            {React.Children.map(children, (child) => {
              return child.props.id === 'rxSelectInput-' + props.selectProps.e2eName ? child : null;
            })}
            {customValueRenderer(props)}
          </>
          : children}
      </components.ValueContainer>
    </>);
};

/**
 * custom dropdown indicator to use project svg icons
 */
export const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}
                                  className={classnames({
                                    [`${createE2EClass(props.selectProps.e2eName + '-toggle', true)}`]: props.selectProps.e2eName,
                                    [props.selectProps.classNamePrefix + '__dropdown-indicator-fill']: props.selectProps.fillDropdownIndicator
                                    && props.selectProps.type === 'dropdown'
                                  })}>
      <svg className={props.selectProps.classNamePrefix + '__dropdown-indicator-toggler-icon'}>
        <use xlinkHref={props.selectProps.menuIsOpen ? '#icon-chevron-up' : '#icon-chevron-down'}/>
      </svg>
    </components.DropdownIndicator>
  );
};

/**
 * custom menu component with wrapper for styling menu
 */
export const Menu = ({children, ...props}) => {
  return (
    <div className={classnames({
      ['rx-select-menu-' + props.selectProps.size]: props.selectProps.size,
    })}>
      <components.Menu {...props} className={classnames(props.selectProps.classNamePrefix + '__menu', {
        [props.selectProps.classNamePrefix + '__menu-' + props.selectProps.tooltipAlign]: props.selectProps.tooltipAlign,
      })}>
        {children}
      </components.Menu>
    </div>
  );
};

/**
 * render option component wrapper for styling and custom content from props.customOptionRenderer if provided
 * @param customOptionRenderer
 */
export const Option = (customOptionRenderer) => ({children, ...props}) => {
  if(props.data.isHeaderOption) {
    return (<div className='rx-select__group-heading'>
      <div className='rx-select__header-content'>{props.selectProps.menuHeader}</div>
      <components.Option {...props}>
        <a
          className={classnames('rx-select__header-close-button',
            { [`${createE2EClass(props.selectProps.e2eName + '-close', true)}`]: props.selectProps.e2eName })}
        >
          <svg className='rx-select__header-close-icon'>
            <use xlinkHref='#icon-delete'/>
          </svg>
        </a>
      </components.Option>
    </div>);
  } else {
    const icon = props.data.icon &&
      <div className='rx-select__option-icon-wrap'>
        <svg className='rx-select__option-icon'>
          <use xlinkHref={props.data.icon}/>
        </svg>
      </div>;
    return (
      <components.Option {...props}
                         className={classnames({ [`${createE2EClass(props.selectProps.e2eName + '-option', true)}`]: props.selectProps.e2eName })}>
        <div className='rx-select__option-content'>
          {customOptionRenderer ? customOptionRenderer(props)
            : <>{icon}
              <div className='rx-select__option-text'>{children}</div>
            </>}
        </div>
      </components.Option>
    );
  }
};
